export default __webpack_public_path__ + "images/pa-8788ab50de263793f74b85d2e6eaba5c.svg";